import React, { Component } from "react"
import { Row, Col } from "elemental"
import { browserHistory } from "react-router"
import Filter from "../components/Filter/Filter"
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs"
import ProductColDetail from "../components/Product/ProductColDetail"
import shop from "shop/shop"

export default class SalesPage extends Component {

  defaultProps = {
    pathname: "articletype"
  }

  constructor( props ) {
    super( props )
    this.state = {
      products: [],
      loaded:   false,
      filter:   {
        total:       12,
        pageSize:    64, // shop.settings.get( "pageSize" ),
        currentPage: 1,
      },
      query:    {
        page:   props.location.page || 1,
        count:  props.location.count || shop.settings.get( "pageSize" ),
        total:  48,
        filter: null,
        limit:  3,
        id:     null
      }
    }
  }

  componentDidMount() {
    this.loadFrom( this.props )
  }

  componentWillReceiveProps( props ) {
    if ( this.mode !== props.params.mode ) {
      this.loadFrom( props )
    }
  }

  loadFrom( props ) {
    console.log( `sales page`, props )
    let mode = props.params.mode
    let { query } = props.location
    query.count = query.count || this.state.query.count
    query.page = query.page || 1
    query.sort = query.sort || "stock"
    this.load( mode, query )
  }

  load( mode = "01", query ) {
    console.log( `loading query`, { mode, query } )

    let filter = new shop.Filter()
    filter
      .searchField( true )
      .field( "articletype" )

    query.filter = filter.query( mode )
    console.log( "SUPER QUERY", { query } )
    shop.products.search( "%%", query )
      .then( res => {
        this.setState( {
          size:     res.size,
          products: res.products,
          query,
        } )
      } )
  }

  onChangeFilter = ( filter ) => {
    this.updateQuery( filter )
  }

  updateQuery( { page, sort, pageSize, dir, id } ) {
    // console.log(`change`, {
    //    page,
    //    sort,
    //    pageSize,
    //    id
    // })
    id = id || this.id
    let query = this.props.location.query
    query.page = page || query.page
    query.count = pageSize || query.count
    query.sort = sort || query.sort || "stock"
    query.dir = dir || query.dir
    delete query.filter
    browserHistory.push( {
      pathname: `/${this.props.pathname || "articletype"}/${this.props.params.mode}`,
      query
    } )
    this.load( this.props.params.mode, query )
  }

  render() {
    let products = this.state.products.map( ( product, key ) => {
      return <ProductColDetail key={key}
                               product={product}> </ProductColDetail>
    } )

    let filter = {
      currentPage: Number( this.state.query.page ),
      total:       Number( this.state.size ) || 6,
      pageSize:    Number( this.state.query.count ),
      id:          String( this.state.query.id ),
      sort:        String( this.state.query.sort )
    }

    let path = []
    path.push( {
      title: this.props.params.mode === "02" ? "Sales" : "Topseller",
      link:  `/${this.props.pathname || "articletype"}/${this.props.params.mode}`
    } )

    return (
      <div className="container ">
        {/*<div>*/}
        {/*<pre>{JSON.stringify(this.state.filter, null, 2) }</pre>*/}
        {/*</div>*/}
        {/*<div><pre>{JSON.stringify(this.props.params, null, 2) }</pre></div>*/}
        <Breadcrumbs path={path}/>
        <Row className="padding-top">
          <Col sm="1">
            {/*Filter*/}
            <section style={{ marginBottom: "0" }}>
              <Filter onChange={this.onChangeFilter} {...filter} />
            </section>
            {/*Products from Category*/}
            <section>
              <Row>
                {products}
              </Row>
            </section>

            {/*Filter*/}
            <section>
              <Filter showFilter={true}
                      onChange={this.onChangeFilter} {...filter} />
            </section>
          </Col>
        </Row>

      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/pages/SalesPage.js